import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MatSelect } from '@angular/material';
import { TranslateService } from '@ngstack/translate';
import { EducationPackageService } from 'src/app/services/http/business/educationPackage/education-package.service';
import { LevelInfoService } from 'src/app/services/http/business/levelInfo/level-info.service';
import { ILevelInfo } from 'src/app/interfaces/levelInfo';
import { IEducationPackage } from 'src/app/interfaces/educationPackage';
import { SurveyService } from 'src/app/services/http/business/survey/survey.service';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { IError } from 'src/app/interfaces/error.interface';

@Component({
  selector: 'app-sur-question-cat-add',
  templateUrl: './sur-question-cat-add.component.html',
  styleUrls: ['./sur-question-cat-add.component.css']
})
export class SurQuestionCatAddComponent implements OnInit {

  param: any;
  errorList: IError[] = [];
  personInfo: any;
  errObject: any;
  form: FormGroup;
  errors = new Array();
  eduPackageList: IEducationPackage;
  levelInfoList: ILevelInfo;

  constructor(
    private fb: FormBuilder,
    public translate: TranslateService,
    private eduPackageService: EducationPackageService,
    private levelInfoService: LevelInfoService,
    private errorService: ErrorsService,
    private snackBar: SnackBarService,
    private surService: SurveyService,
    public dialogRef: MatDialogRef<SurQuestionCatAddComponent>,

  ) { }

  ngOnInit() {
    this.createForm();
    this.getEduPackage();
  }

  createForm() {
    this.form = this.fb.group({
      PackageId: [null, Validators.required],
      LevelInfoId: [null, Validators.required],
      Title: [null, Validators.required],
      Explain: ['دانشجوی گرامی، پیش از رویت نمرات آزمون، خواهشمند است به سوالات زیر پاسخ دهید', Validators.required]
    });
  }

  getEduPackage() {
    this.eduPackageService.getList().subscribe(
      res => {
        this.eduPackageList = res.DataList;
      },
      () => {
        
      }
    );
  }

  getLevelInfo(e: MatSelect) {
    this.levelInfoService.getList(e.value).subscribe(
      res => {
        this.levelInfoList = res.DataList;
      },
      () => {
        
      }
    );
  }

  submit(data: any) {
    this.surService.saveCat(data).subscribe(
      () => {
        this.dialogRef.close(true);
        this.snackBar.OpenSnackBar(
          "ثبت با موفقیت انجام شد",
          "ok",
          5000,
          SoundEnum.beep
        );
      },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);
      }
    );
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
